import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { colorPalette } from "../../styles/theme";

/**
 * 사이드바 상단 사용자 정보 카드
 * 이름, 소속, 비밀번호 변경/로그아웃 버튼을 표시합니다.
 *
 * @param {object} me - 현재 로그인한 관리자 정보
 * @param {Function} onChangePassword - 비밀번호 변경 클릭 핸들러
 * @param {Function} onLogout - 로그아웃 클릭 핸들러
 */
const UserCard = ({ me, onChangePassword, onLogout }) => {
  return (
    <Paper sx={{ p: 2, backgroundColor: colorPalette.white }}>
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        이름 : {me?.name || "ㅇㅇㅇ"}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: colorPalette.textSecondary, mb: 2 }}
      >
        소속 : {me?.organization || "소속 없음"}
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          fullWidth
          onClick={onChangePassword}
          sx={{ fontSize: 12 }}
        >
          비밀번호 변경
        </Button>
        <Button
          variant="outlined"
          size="small"
          fullWidth
          onClick={onLogout}
          sx={{ fontSize: 12 }}
        >
          로그아웃
        </Button>
      </Box>
    </Paper>
  );
};

export default UserCard;
